
      import SendBack from './send-back.vue'
      import type { App, Plugin } from 'vue'

      export const SendBackPlugin: Plugin = {
        install(app: App) {
          app.component('SendBack', SendBack)
        },
      }
      export { SendBack }
      